import Login from './views/Login/login'
import Dashboard from './Layout/Dashboard/dashboard'
import IacstResults from './components/Result/IacstResults/result'
import { BrowserRouter, Switch, Route } from 'react-router-dom'
import { useEffect } from 'react'
import EventContext from './eventContext'
import { handleEventLogs } from './events'

import './sass/custom.scss'
import ToastMessage from 'components/shared/ToastMessage'
import { connect } from 'react-redux'
import { SET_TOAST_DATA } from 'constants/actionTypes'
import ForgotPassword from 'views/Login/ForgotPassword'
import Exigency from './Layout/exigency/index'
import PageNotFound from 'views/404'
import Signup from 'Layout/signup'
import Home from 'components/AntheHome/Home'

const mapStateToProps = (state) => ({
    toastData: state.toastMsgs,
})

const mapDispatchToProps = (dispatch) => ({
    setToastMsgsData: (payload) => {
        dispatch({ type: SET_TOAST_DATA, payload })
    },
})

const App = (props) => {
    useEffect(() => {
        let timer
        if (props.toastData.isToastOpen)
            timer = setTimeout(() => {
                props.setToastMsgsData({
                    isToastOpen: false,
                    toastMessage: '',
                })
            }, 5000)

        return () => {
            clearTimeout(timer)
        }

        // eslint-disable-next-line
    }, [props.toastData.isToastOpen])

    useEffect(() => {
        // document.addEventListener("contextmenu", (event) => {
        //     alert("Right click is disabled for this site");
        //     event.preventDefault();
        //   });
        document.onkeydown = function (e) {
            if (e.keyCode === 123) {
                return false
            }
            if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
                return false
            }
            if (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) {
                return false
            }
            if (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) {
                return false
            }
            if (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) {
                return false
            }
        }
    }, [])

    return (
        <BrowserRouter>
            <EventContext.Provider value={handleEventLogs}>
                <Switch>
                    <Route exact path="/" render={() => <Login />} />
                    <Route exact path="/login" render={() => <Login />} />
                    {/* <Route exact path="/anthe-exam">
                        <Signup />
                    </Route> */}
                    <Route path="/anthe-exigency">
                        <Exigency />
                    </Route>
                    <Route path="/akthe-exigency">
                        <Exigency />
                    </Route>
                    <Route
                        exact
                        path="/recover-credentials"
                        render={() => <ForgotPassword />}
                    />

                    <Route exact path="/dashboard" render={() => <Dashboard />} />

                    { <Route
                        exact
                        path="/iacst-result"
                        render={() => <IacstResults />}
                    /> }
                    {/* <Route  path="/" >
                        <Home />
                    </Route> */}

                    <Route path="/404" render={() => <PageNotFound />} />
                    <Route path="*" render={() => <PageNotFound />} />
                </Switch>
            </EventContext.Provider>

            <ToastMessage
                isToastOpen={props.toastData.isToastOpen}
                toastType={props.toastData.toastType}
                toastMessage={props.toastData.toastMessage}
            />
        </BrowserRouter>
    )
}
export default connect(mapStateToProps, mapDispatchToProps)(App)
